
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ServiceAreasPage = () => {
  const serviceAreas = [
    {
      city: 'New York',
      state: 'NY',
      description: 'Comprehensive AI marketing solutions for businesses in the greater New York metropolitan area.',
      services: ['AI Marketing Automation', 'Business Development', 'Lead Generation', 'Conversational AI'],
      image: 'https://public.readdy.ai/ai/img_res/a7542a9ea4aed30503f4342402995264.jpg'
    },
    {
      city: 'Los Angeles',
      state: 'CA',
      description: 'Cutting-edge AI solutions tailored for the dynamic Los Angeles business landscape.',
      services: ['Digital Marketing', 'AI Implementation', 'Performance Analytics', 'Customer Engagement'],
      image: 'https://readdy.ai/api/search-image?query=Los%20Angeles%20downtown%20business%20district%20with%20modern%20skyscrapers%2C%20California%20sunshine%2C%20professional%20corporate%20environment%20with%20technology%20integration&width=400&height=250&seq=la1&orientation=landscape'
    },
    {
      city: 'Chicago',
      state: 'IL',
      description: 'Strategic AI marketing services designed for Chicago\'s diverse business community.',
      services: ['Marketing Automation', 'Business Growth', 'AI Consulting', 'ROI Optimization'],
      image: 'https://readdy.ai/api/search-image?query=Chicago%20business%20district%20with%20iconic%20architecture%2C%20professional%20corporate%20towers%2C%20midwest%20business%20environment%20with%20modern%20technology%20elements&width=400&height=250&seq=chi1&orientation=landscape'
    },
    {
      city: 'Miami',
      state: 'FL',
      description: 'Innovative AI marketing strategies for Miami\'s vibrant business ecosystem.',
      services: ['Lead Nurturing', 'Conversational AI', 'Market Analysis', 'Growth Strategies'],
      image: 'https://readdy.ai/api/search-image?query=Miami%20business%20district%20with%20modern%20glass%20buildings%2C%20tropical%20professional%20environment%2C%20Florida%20sunshine%20with%20high-tech%20business%20atmosphere&width=400&height=250&seq=mia1&orientation=landscape'
    },
    {
      city: 'Dallas',
      state: 'TX',
      description: 'Powerful AI solutions driving business success across the Dallas-Fort Worth metroplex.',
      services: ['AI Integration', 'Business Development', 'Marketing Optimization', 'Performance Tracking'],
      image: 'https://readdy.ai/api/search-image?query=Dallas%20business%20skyline%20with%20modern%20corporate%20buildings%2C%20Texas%20professional%20environment%2C%20urban%20business%20district%20with%20technology%20innovation&width=400&height=250&seq=dal1&orientation=landscape'
    },
    {
      city: 'Seattle',
      state: 'WA',
      description: 'Advanced AI marketing solutions for Seattle\'s tech-forward business community.',
      services: ['Tech Integration', 'AI Automation', 'Digital Transformation', 'Growth Analytics'],
      image: 'https://readdy.ai/api/search-image?query=Seattle%20business%20district%20with%20modern%20tech%20buildings%2C%20Pacific%20Northwest%20professional%20environment%2C%20innovative%20corporate%20atmosphere%20with%20AI%20technology&width=400&height=250&seq=sea1&orientation=landscape'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              AI Marketing Services Across Major Markets
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
              We provide comprehensive AI marketing solutions and business development services to help companies grow across key metropolitan areas.
            </p>
            
            {/* Callback Request Form */}
            <div className="max-w-md mx-auto bg-white p-6 rounded-xl shadow-lg">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Request a Local Consultation</h3>
              <form 
                action="https://readdy.ai/api/form/d44s6qn0vhksjg8rfn1g" 
                method="POST" 
                data-readdy-form
                className="space-y-4"
              >
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <select
                  name="location"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-8"
                >
                  <option value="">Select Your Location</option>
                  {serviceAreas.map((area) => (
                    <option key={`${area.city}-${area.state}`} value={`${area.city}, ${area.state}`}>
                      {area.city}, {area.state}
                    </option>
                  ))}
                </select>
                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Request Callback
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Service Areas Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Service Areas</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We provide localized AI marketing solutions tailored to each market's unique business environment and opportunities.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {serviceAreas.map((area) => (
              <div key={`${area.city}-${area.state}`} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="aspect-video overflow-hidden">
                  <img
                    src={area.image}
                    alt={`${area.city}, ${area.state} business district`}
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {area.city}, {area.state}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {area.description}
                  </p>
                  
                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-900 mb-2">Available Services:</h4>
                    <div className="flex flex-wrap gap-2">
                      {area.services.map((service, index) => (
                        <span key={index} className="text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <button className="w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                    Get Local Quote
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Local SEO Benefits */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Why Choose Local AI Marketing Expertise?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our local market knowledge combined with cutting-edge AI technology delivers superior results for businesses in each metropolitan area.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-map-pin-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Local Market Knowledge</h3>
              <p className="text-gray-600">
                Deep understanding of local business landscapes, customer behaviors, and market opportunities in each metropolitan area.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-robot-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">AI-Powered Solutions</h3>
              <p className="text-gray-600">
                Advanced artificial intelligence tools and strategies customized for local market dynamics and business requirements.
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-line-chart-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Proven Results</h3>
              <p className="text-gray-600">
                Track record of delivering measurable growth and ROI improvements for businesses across all our service areas.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServiceAreasPage;
